<template>
    <div>
        <div>
            <div class="flex flex-row text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div @click="goBack" class="flex flex-row cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
            </div>
        </div>
        <div class="flex flex-row justify-around">
            <form @submit.prevent="saved" @keydown="form.errors.clear($event.target.name)"
                  class="flex flex-row justify-center w-full">
                <div class="pb-4 pt-2 rounded shadow-md w-full bg-white">
                    <div class="text-grey-darkest text-base text mb-8 border-b-2 border-followup-nav pl-4 pb-2">
                        New Company
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="name"
                                   :class="{'text-red': form.errors.has('name')}">Name</label>
                            <input v-model="form.name" id="name" name="name" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('name')}">
                            <div class="text-red text-sm" v-if="form.errors.has('name')">{{ form.errors.get('name') }}
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="address"
                                   :class="{'text-red': form.errors.has('address')}">Address</label>
                            <input v-model="form.address" id="searchTextField" name="address" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('address')}">
                            <div class="text-red text-sm" v-if="form.errors.has('address')">{{
                                form.errors.get('address') }}
                            </div>
                            <input v-model="form.lat" type="hidden" name="lat"
                                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                            <input v-model="form.lng" type="hidden" name="lng"
                                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="city"
                                   :class="{'text-red': form.errors.has('city')}">City</label>
                            <input v-model="form.city" type="text" name="city" id="city" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('city')}">
                            <div class="text-red text-sm" v-if="form.errors.has('city')">{{ form.errors.get('city') }}
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="state"
                                   :class="{'text-red': form.errors.has('state')}">State</label>
                            <input v-model="form.state" type="text" id="state" title="state" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('state')}">
                            <div class="text-red text-sm" v-if="form.errors.has('state')">{{ form.errors.get('state')
                                }}
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="zip"
                                   :class="{'text-red': form.errors.has('zip')}">Zip</label>
                            <input v-model="form.zip" type="text" id="zip" name="zip" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('zip')}">
                            <div class="text-red text-sm" v-if="form.errors.has('zip')">{{ form.errors.get('zip') }}
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="phone"
                                   :class="{'text-red': form.errors.has('phone')}">Phone</label>

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        {{symbols.DDI}}
                                    </span>
                                </div>
                                <input v-model="form.phone" id="phone" title="phone" maxlength="64"
                                   v-mask="masks.v_mask_phone"
                                   class="form-control bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('phone')}">
                            </div>
                            <div class="text-red text-sm" v-if="form.errors.has('phone')">{{ form.errors.get('phone')
                                }}
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="fax"
                                   :class="{'text-red': form.errors.has('fax')}">Fax</label>
                            <input v-model="form.fax" id="fax" name="fax" maxlength="64"
                                   v-mask="masks.v_mask_phone"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('fax')}">
                            <div class="text-red text-sm" v-if="form.errors.has('fax')">{{ form.errors.get('fax') }}
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm"
                                   :class="{'text-red': form.errors.has('company_types_id')}">Company Type</label>
                                <div class="flex-col ">
                                    <multiselect
                                        class="cursor-pointer"
                                        :options="companyTypes"
                                        v-model="selectedCompanyType"
                                        :show-labels="false"
                                        @input="form.errors.clear('company_types_id')"
                                        track-by="id"
                                        label="code"
                                        value="id">
                                    </multiselect>
                                    <div class="text-red text-sm" v-if="form.errors.has('company_types_id')">The company type field is required.</div>
                            </div>
                        </div>
                    </div>


                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full flex flex-no-wrap mr-6">
                            <div class="w-4/5">
                                <label class="text-grey-darkest text-sm" for="contact_name"
                                    :class="{'text-red': form.errors.has('contact_name')}">Contact</label>
                                <input v-model="form.contact_name" id="contact_name" name="contact_name" maxlength="64"
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': form.errors.has('contact_name')}">
                                <div class="text-red text-sm" v-if="form.errors.has('contact_name')">{{
                                    form.errors.get('contact_name') }}
                                </div>
                            </div>
                            <div class="w-1/5 flex justify-center items-center">
                                <div class="text-center cursor-pointer table mb-0"
                                    @click.prevent.stop="openCompanyContactModal()">
                                    <i class="fa fa-user fa-2x"></i>
                                    <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3 w-full ">
                            <label class="text-grey-darkest text-sm" for="fax"
                                   :class="{'text-red': form.errors.has('site')}">Web Site</label>
                            <input v-model="form.site" id="site" name="site" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('site')}">
                            <div class="text-red text-sm" v-if="form.errors.has('site')">{{ form.errors.get('site') }}
                            </div>
                        </div>

                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="contact_cell"
                                   :class="{'text-red': form.errors.has('contact_cell')}">Cell</label>
                            <input v-model="form.contact_cell" id="contact_cell" title="contact_cell" maxlength="64"
                                   v-mask="masks.v_mask_phone"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('contact_cell')}">
                            <div class="text-red text-sm" v-if="form.errors.has('contact_cell')">{{
                                    form.errors.get('contact_cell') }}
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="contact_email"
                                   :class="{'text-red': form.errors.has('contact_email')}">Email</label>
                            <input v-model="form.contact_email" id="contact_email" name="contact_email" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('contact_email')}">
                            <div class="text-red text-sm" v-if="form.errors.has('contact_email')">{{
                                form.errors.get('contact_email') }}
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="contact_title"
                                   :class="{'text-red': form.errors.has('contact_title')}">Title</label>
                            <input v-model="form.contact_title" id="contact_title" name="contact_title"
                                   maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('contact_title')}">
                            <div class="text-red text-sm" v-if="form.errors.has('contact_title')">{{
                                    form.errors.get('contact_title') }}
                            </div>
                        </div>
                         <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm"
                                   :class="{'text-red': form.errors.has('contact_types_id')}">Contact Type</label>
                            <multiselect
                                class="cursor-pointer"
                                :options="contactTypes"
                                v-model="selectedContactType"
                                :show-labels="false"
                                :class="{'border-red': form.errors.has('contact_types_id')}"
                                @input="form.errors.clear('contact_types_id')"
                                track-by="id"
                                label="code"
                                value="id">
                            </multiselect>
                            <div class="text-red" v-if="form.errors.has('contact_types_id')">{{ form.errors.get('contact_types_id') }}</div>
                        </div>
                    </div>

                    <company-custom-fields ref="CompanyCustomFields" base="create" :foundationAutoGeneratedCustomerNo="foundationAutoGeneratedCustomerNo" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" :customFieldErrors="form.errors"></company-custom-fields>

                    <div class="flex flex-row justify-end mt-4 pr-4">
                        <a href="/company" class="flex items-center mr-4 text-teal hover:text-teal-dark">
                            Cancel
                        </a>
                        <button class="py-2 px-4 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark bg-teal">
                            <i class="fa fa-spin fa-spinner text-white" v-if="saveLoader" aria-hidden="true"></i>&nbsp;&nbsp;
                            <span class="text-white font-bold">Create</span>
                        </button>
                    </div>
                </div>
            </form>
            <div class="modal" id="exist_contact" tabindex="-1">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                        <div class="modal-header">
                            <div class="row" style="height: 200px;">
                                <div class="col-md-12" style="text-align: center; font-size:25px; margin-top:15px;font-weight: bold;">This company already exists</div>
                                <div class="col-md-12" style="text-align: center;" data-dismiss="modal">
                                    <button type="button" @click="pageReload" class="btn btn-primary" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                    > Cancel</button>
                                    <button type="button" @click="contactDetails()" class="btn btn-default" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px; background:rgb(152 151 151);color: white;"
                                    >Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <company-contact-modal ref="CompanyContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="exchange" @selected="parseContact"></company-contact-modal>
            <project-contact-modal ref="EmailContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="exchange" @selected="parseContact"></project-contact-modal>
        </div>
    </div>
</template>

<script>

    import Form from "../../utils/form";
    import Multiselect from 'vue-multiselect';
    import Swal from "sweetalert2";
    let autocomplete=null;

    export default {
        name: 'company-create',
        components: {Multiselect},
        props:['masks', 'symbols','exchange', 'foundationAutoGeneratedCustomerNo', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess'],
        data() {
            return {
                form: new Form({
                    name: '',
                    address: '',
                    lat: '',
                    lng: '',
                    city: '',
                    state: '',
                    zip: '',
                    phone: '',
                    fax: '',
                    site: '',
                    company_types_id: null,
                    contact_name: '',
                    contact_cell: '',
                    contact_email: '',
                    contact_title: '',
                    contact_types_id: null,
                    company_id:null,
                    customFieldsData: null,
                    foundationCustomerNo: null,
                    isFoundationNoFollowupPrimaryKey: false
                }),
                selectedCompanyType: null,
                companyTypes: [],
                selectedContactType: null,
                contactTypes: [],
                saveLoader: false
            }
        },
        mounted(){
            this.initAutocomplete();
            Bus.$on('openEmailContactModalParent', data => {
                console.log('data',data);
                this.$refs.CompanyContactModal.close();
                this.$refs.EmailContactModal.open();
            });
            Bus.$on('openCompanyContactModal', data => {
                this.$refs.EmailContactModal.close();
                this.$refs.CompanyContactModal.open();

            });
            this.getCompanyTypes();
            this.getContactTypes();
        },
        watch:{
            selectedCompanyType(val){
                this.form.company_types_id = val.id;
            },
            selectedContactType(val){
                this.form.contact_types_id = val.id;
            }
        },
        methods: {
            initAutocomplete() {
                let input = document.getElementById('searchTextField');
                autocomplete = new google.maps.places.Autocomplete(input, {
                    componentRestrictions: {
                        country: ['us','ca']
                    }
                });
                google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponents);
            },
            getAddressComponents() {
                let placeResultData = autocomplete.getPlace();
                this.form.lat = placeResultData.geometry.location.lat();
                this.form.lng = placeResultData.geometry.location.lng();
                this.form.zip = '';
                this.form.city = '';
                this.form.state = '';
                placeResultData.address_components.map(res=>{
                    if(res.types[0]==='postal_code'){
                        this.form.zip = res.short_name;
                    }
                    if(res.types[0]==='locality'){
                        this.form.city = res.short_name;
                    }
                    if(res.types[0]==='administrative_area_level_1'){
                        this.form.state = res.short_name;
                    }
                });
                this.form.address = placeResultData.name;
            },
            saved() {
                this.form.post(route('api.company.check')).then((response) => {
                    if (response.status == 'error') {
                        Swal.fire({
                            title: 'Company Already Exists',
                            text: "Do you want to create a duplicate company",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'Continue creating!'
                        }).then((result) => {
                            if (result.value) {
                                this.form.post(route('api.company.contact.check', {company: 0, fromWhere: 'company'})).then((responseData) => {
                                    if (responseData.status == 'error') {
                                        Swal.fire({
                                            title: 'Company Contact Already Exists',
                                            text: "Do you want to create a duplicate contact",
                                            type: 'warning',
                                            showCancelButton: true,
                                            confirmButtonColor: '#01B1AF',
                                            confirmButtonText: 'Continue creating!'
                                        }).then((result) => {
                                            if (result.value) {
                                                this.savedAfterCheck();
                                            }else{
                                                return false
                                            }
                                        });
                                    }else{
                                        this.savedAfterCheck();
                                    }
                                });
                            }else{
                                return false;
                            }
                        });
                    }else{
                        this.form.post(route('api.company.contact.check', {company: 0, fromWhere: 'company'})).then((res) => {
                            if (res.status == 'error') {
                                Swal.fire({
                                    title: 'Company Contact Already Exists',
                                    text: "Do you want to create a duplicate contact",
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#01B1AF',
                                    confirmButtonText: 'Continue creating!'
                                }).then((result) => {
                                    if (result.value) {
                                        this.savedAfterCheck();
                                    }else{
                                        return false
                                    }
                                });
                            }else{
                                this.savedAfterCheck();
                            }
                        });
                    }
                });
            },

            openCompanyContactModal() {
                this.$refs.CompanyContactModal.open();
            },

            parseContact(contact) {
                this.form.contact_name  = contact.name;
                if (contact.phone != null){
                    this.form.contact_cell  = contact.phone;
                }else {
                    this.form.contact_cell  = contact.cell;
                }
                this.form.contact_email = contact.email;
            },
            getCompanyTypes() {
                let self = this;
                axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                    self.companyTypes = data;
                    self.companyTypes.push({id:null,code:""})
                });
            },
            getContactTypes() {
                let self = this;
                axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                    self.contactTypes = data.filter(x => !x.is_residential);
                    self.contactTypes.push({id:null,code:""})
                });
            },
            goBack() {
                window.location = "/company";
            },
            pageReload(){
                window.location.reload();
            },
            contactDetails(){
                window.location = "/company/" + this.form.company_id;
            },
            savedAfterCheck() {
                let self = this;
                self.form.customFieldsData = self.$refs.CompanyCustomFields.form;

                if(self.foundationCustomerAccess) {
                    self.form.post(route('api.company.check-foundation-customer-scenarios')).then((data) => {
                        if(data.pass) {
                            if(data.foundationCustomerNo) {
                                self.form.foundationCustomerNo = data.foundationCustomerNo;
                                self.form.isFoundationNoFollowupPrimaryKey = data.isFollowupPrimaryKey;
                                Swal.fire({
                                    title: 'Foundation',
                                    text: "Note: If a record exists with the same customer # or email address on Foundation, this will update the existing record. If neither of these exist on Foundation, a new customer record will be created.",
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonColor: '#01B1AF',
                                    confirmButtonText: 'Confirm'
                                }).then((result) => {
                                    if (result.value) {
                                        self.finalSaveRequest();
                                    }
                                });
                            }
                            else {
                                self.finalSaveRequest();
                            }
                        }
                        else {
                            self.form.foundationCustomerNo = null;
                            self.form.isFoundationNoFollowupPrimaryKey = false;
                            self.getToast(4000).fire({
                                type: 'error',
                                title: data.message
                            });
                        }
                    }).catch((error) => {
                        self.form.foundationCustomerNo = null;
                        self.form.isFoundationNoFollowupPrimaryKey = false;
                    });
                }
                else {
                    self.finalSaveRequest();
                }
            },
            finalSaveRequest() {
                let self = this;
                self.saveLoader = true;
                this.form.post(route('api.company.store')).then((data) => {
                    self.saveLoader = false;
                    if (data.exists){
                        this.form.company_id = data.company_id;
                        $('#exist_contact').modal('show');
                    }else {
                        this.$refs.CompanyCustomFields.submit(data.data.id, data.foundationCustomerNo);
                        self.getToast(4000).fire({
                            type: 'success',
                            title: data.message.message,
                        });
                        if(self.foundationCustomerAccess && !data.foundationCustomerNo && data.foundationMsg !== '') {
                            self.getToast(4000).fire({
                                type: 'error',
                                title: data.foundationMsg,
                            });
                            window.location = "/company/" + data.data.id;
                        }
                        else {
                            window.location = "/company/" + data.data.id;
                        }
                    }
                }).catch((error) => {
                    self.saveLoader = false;
                });
            }
        }
    }
</script>

<style scoped>
    .lg\:w-1\/2 {
        width: 49% !important;
    }
</style>
